import { Injectable } from '@angular/core';
import RestService from 'src/app/utils/restservice';

@Injectable({
  providedIn: 'root'
})
export class TransportService {
  constructor(private restService: RestService) {}

  search(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('transports/search', val_params);
  }

  all(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('transports/all', val_params);
  }

  list(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('transports/list', val_params);
  }

  get(val_id: number) {
    return this.restService.get('transports/edit', val_id);
  }

  save(data: any) {
    return this.restService.save('transports/save', data);
  }

  update(val_id: number, data: any) {
    return this.restService.update('transports/update', val_id, data);
  }

  delete(val_id: number) {
    return this.restService.delete('transports/delete', val_id);
  }
}
